// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__4yPje","vLegacy":"SelectSecondary_vLegacy__nAiVC","error":"SelectSecondary_error__2Y8qK","disabled":"SelectSecondary_disabled__3ecIA"};